import { APIError, createAPIRequest, createAPIResponse, ResponseWrapper } from '@tlx/astro-shared';
import { APIUrls } from '@Util/urls';
import useSWR from 'swr';

export type Month =
    | 'JANUARY'
    | 'FEBRUARY'
    | 'MARCH'
    | 'APRIL'
    | 'MAY'
    | 'JUNE'
    | 'JULY'
    | 'AUGUST'
    | 'SEPTEMBER'
    | 'OCTOBER'
    | 'NOVEMBER'
    | 'DECEMBER'
    | 'NOT_CHOSEN';

export type SalarySettingsDTO = {
    halfTaxMonth: Month;
    vacationCorrectionMonth: Month;
    vacationMonth: Month;
    vacationPayMonth: Month;
    isPaidInAdvance: boolean;
    isUnionDeduction: boolean;
    isFreeCar: boolean;
    taxBankAccountNumber: string;
    moduleSalaryApproval: boolean;
};

export function useSalarySettings() {
    const { data, error, isLoading } = useSWR<ResponseWrapper<SalarySettingsDTO>, APIError>(APIUrls.SALARY_SETTINGS, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });

    return { data: data?.value, error, isLoading };
}

export async function updateSalarySettings(dto: Partial<SalarySettingsDTO>) {
    const request = createAPIRequest(APIUrls.SALARY_SETTINGS, {
        method: 'PUT',
        body: JSON.stringify(dto),
        headers: {
            'content-type': 'application/json; charset=utf-8',
        },
    });
    const response = await window.fetch(request);
    return await createAPIResponse(request, response);
}
